import { Controller } from "@hotwired/stimulus"

// Refuses a file above the server's size limit before it is uploaded: the browser blocks
// the submit with the message via the native validity API, so nothing is sent for minutes
// only to be rejected afterwards. The server validation stays authoritative. With maxFiles
// set, more files than the server takes at once are refused the same way.
export default class extends Controller {
  static values = { max: Number, message: String, maxFiles: Number, tooManyMessage: String }

  check() {
    this.element.setCustomValidity(this.problem() || "")
    if (!this.element.validity.valid) this.element.reportValidity()
  }

  problem() {
    const files = Array.from(this.element.files)
    if (this.hasMaxFilesValue && files.length > this.maxFilesValue) return this.tooManyMessageValue

    const tooLarge = files.find((file) => file.size >= this.maxValue)
    return tooLarge && this.messageValue.replace("%{filename}", tooLarge.name)
  }
}
